import { useState, useEffect } from 'react';

/**
 * Lightweight hook for landing page components to detect dark mode.
 * Reads the `dark` class from <html> (set by Navbar's theme toggle)
 * and listens for changes via MutationObserver.
 */
export function useLandingTheme(): boolean {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
}
